export default __webpack_public_path__ + "static/media/gallery_06.6d683ca2.jpg";